import React from 'react'
import './Button.css'

function MyResumeButton() {
  return (
	<div>
		<button className='resume-button bold'>RESUME</button>
	</div>
  )
}

export default MyResumeButton